import {
  PathologyState,
  PathologyActionTypes,
  pathologyAction,
} from "../../types/pathology";

const initialState: PathologyState = {
  pathology: null,
  loading: false,
  error: null,
};

export const pathologyReducer = (
  state: PathologyState = initialState,
  action: pathologyAction
): PathologyState => {
  switch (action.type) {
    case PathologyActionTypes.GET_MARKUP_PATHOLOGY: {
      return { ...state, loading: true };
    }
    case PathologyActionTypes.GET_MARKUP_PATHOLOGY_SUCCESS: {
      return { ...state, loading: false, pathology: action.payload };
    }
    case PathologyActionTypes.GET_MARKUP_PATHOLOGY_ERROR: {
      return { ...state, loading: false, error: action.payload };
    }
    case PathologyActionTypes.GET_PATHOLOGY: {
      return { ...state, loading: true };
    }
    case PathologyActionTypes.GET_PATHOLOGY_SUCCESS: {
      return { ...state, loading: false, pathology: action.payload };
    }
    case PathologyActionTypes.GET_PATHOLOGY_ERROR: {
      return { ...state, loading: false, error: action.payload };
    }

    case PathologyActionTypes.SAVE_MARKUP_PATHOLOGY: {
      return { ...state, loading: true };
    }
    case PathologyActionTypes.SAVE_MARKUP_PATHOLOGY_SUCCESS: {
      return { ...state, loading: false };
    }
    case PathologyActionTypes.SAVE_MARKUP_PATHOLOGY_ERROR: {
      return { ...state, loading: false, error: action.payload };
    }

    case PathologyActionTypes.VALIDATE_PATHOLOGY: {
      return { ...state, loading: true };
    }
    case PathologyActionTypes.VALIDATE_PATHOLOGY_SUCCESS: {
      return { ...state, loading: false };
    }
    case PathologyActionTypes.VALIDATE_PATHOLOGY_ERROR: {
      return { ...state, loading: false, error: action.payload };
    }

    case PathologyActionTypes.DELETE_PATHOLOGY: {
      return { ...state, loading: true };
    }
    case PathologyActionTypes.DELETE_PATHOLOGY_SUCCESS: {
      return { ...state, loading: false };
    }
    case PathologyActionTypes.DELETE_PATHOLOGY_ERROR: {
      return { ...state, loading: false, error: action.payload };
    }

    default:
      return state;
  }
};
